import { Box } from "@mui/material";
import React from "react";
import Text from "./text/Text";
import WalletSymbols from "./WalletSymbols";
import { insufficientBalance, insufficientBalanceMsg } from "./messages";
import {
  displayAmount,
  displayTaprootCurrency,
  getDisplayCurrencySymbol,
} from "./constants";

const InsufficientBalanceMsgBox = ({
  isFromBrowser,
  isLightningMethod,
  balance,
  exchangeRate,
  checkExchange,
  targetedCurrency,
  targetedCurrencySymbol,
  currency,
  amount,
  showBtcAmount,
  calculatedSpeedFees,
  networkFeeAmount,
}) => {
  const textSize = isFromBrowser ? 16 : 14;

  const showSubMsg = isLightningMethod && amount <= balance;

  const totalToKeepInWallet = calculatedSpeedFees + networkFeeAmount;
  const amountToKeepInWallet = showBtcAmount
    ? totalToKeepInWallet?.toFixed(8)
    : Math.floor(totalToKeepInWallet);

  const isNegativeBalance = balance < 0;
  const finalDisplayAmount = displayAmount(
    Math.abs(balance),
    exchangeRate,
    targetedCurrency,
    currency,
    checkExchange
  );
  return (
    <Box
      className="send-via-error-section"
      sx={{
        marginBottom: isFromBrowser ? "12px" : "8px",
      }}
    >
      <>
        <Box display="flex" flexDirection="column" flex={1}>
          <Text
            className="error-text"
            size={textSize}
            font="semibold"
            sx={{ display: "flex", alignItems: "center" }}
          >
            <WalletSymbols
              symbol="error"
              sx={{ color: "#fd371e", marginRight: "4px" }}
            />{" "}
            {insufficientBalance}
          </Text>
          {showSubMsg && (
            <Text
              className="error-text"
              size={isFromBrowser ? 14 : 12}
              font="regular"
            >
              {insufficientBalanceMsg(amountToKeepInWallet, showBtcAmount)}
            </Text>
          )}
        </Box>
        <Box>
          <Text className="error-text" size={14} font="semibold">
            {isNegativeBalance && "-"}
            {checkExchange ? targetedCurrencySymbol : getDisplayCurrencySymbol(currency, showBtcAmount)}
            {finalDisplayAmount}
            {!checkExchange && displayTaprootCurrency(balance, currency)}
          </Text>
        </Box>
      </>
    </Box>
  );
};

export default InsufficientBalanceMsgBox;
